/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiEntityType,
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeToJSON,
    InternalApiScreeningClearanceRulesAnalysesPage,
    InternalApiScreeningClearanceRulesAnalysesPageFromJSON,
    InternalApiScreeningClearanceRulesAnalysesPageToJSON,
    InternalApiScreeningClearanceRulesAnalysis,
    InternalApiScreeningClearanceRulesAnalysisFromJSON,
    InternalApiScreeningClearanceRulesAnalysisToJSON,
    InternalApiScreeningClearanceRulesAnalysisRun,
    InternalApiScreeningClearanceRulesAnalysisRunFromJSON,
    InternalApiScreeningClearanceRulesAnalysisRunToJSON,
} from '../models';

export interface AddAnalysisRequest {
    internalApiScreeningClearanceRulesAnalysis: InternalApiScreeningClearanceRulesAnalysis;
}

export interface AddRunRequest {
    analysisId: number;
    internalApiScreeningClearanceRulesAnalysisRun: InternalApiScreeningClearanceRulesAnalysisRun;
}

export interface DeleteAnalysisRequest {
    id: number;
}

export interface FindAllAnalysesWithRunInfoRequest {
    page: number;
    size: number;
    entityType: InternalApiEntityType;
}

export interface FindAllRunsRequest {
    analysisId: number;
}

export interface GetAnalysisRequest {
    id: number;
}

export interface UpdateAnalysisRequest {
    id: number;
    internalApiScreeningClearanceRulesAnalysis: InternalApiScreeningClearanceRulesAnalysis;
}

/**
 * 
 */
export class ScreeningClearanceRulesAnalysisApi extends runtime.BaseAPI {

    /**
     * Creates new screening clearance rules analysis
     */
    async addAnalysisRaw(requestParameters: AddAnalysisRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningClearanceRulesAnalysis>> {
        if (requestParameters.internalApiScreeningClearanceRulesAnalysis === null || requestParameters.internalApiScreeningClearanceRulesAnalysis === undefined) {
            throw new runtime.RequiredError('internalApiScreeningClearanceRulesAnalysis','Required parameter requestParameters.internalApiScreeningClearanceRulesAnalysis was null or undefined when calling addAnalysis.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/analyses`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScreeningClearanceRulesAnalysisToJSON(requestParameters.internalApiScreeningClearanceRulesAnalysis),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningClearanceRulesAnalysisFromJSON(jsonValue));
    }

    /**
     * Creates new screening clearance rules analysis
     */
    async addAnalysis(requestParameters: AddAnalysisRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningClearanceRulesAnalysis> {
        const response = await this.addAnalysisRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates new screening clearance rules analysis run
     */
    async addRunRaw(requestParameters: AddRunRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningClearanceRulesAnalysisRun>> {
        if (requestParameters.analysisId === null || requestParameters.analysisId === undefined) {
            throw new runtime.RequiredError('analysisId','Required parameter requestParameters.analysisId was null or undefined when calling addRun.');
        }

        if (requestParameters.internalApiScreeningClearanceRulesAnalysisRun === null || requestParameters.internalApiScreeningClearanceRulesAnalysisRun === undefined) {
            throw new runtime.RequiredError('internalApiScreeningClearanceRulesAnalysisRun','Required parameter requestParameters.internalApiScreeningClearanceRulesAnalysisRun was null or undefined when calling addRun.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/analyses/{analysisId}/runs`.replace(`{${"analysisId"}}`, encodeURIComponent(String(requestParameters.analysisId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScreeningClearanceRulesAnalysisRunToJSON(requestParameters.internalApiScreeningClearanceRulesAnalysisRun),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningClearanceRulesAnalysisRunFromJSON(jsonValue));
    }

    /**
     * Creates new screening clearance rules analysis run
     */
    async addRun(requestParameters: AddRunRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningClearanceRulesAnalysisRun> {
        const response = await this.addRunRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an screening clearance rules analysis
     */
    async deleteAnalysisRaw(requestParameters: DeleteAnalysisRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteAnalysis.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/analyses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an screening clearance rules analysis
     */
    async deleteAnalysis(requestParameters: DeleteAnalysisRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteAnalysisRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches all clearance rules analyses
     */
    async findAllAnalysesWithRunInfoRaw(requestParameters: FindAllAnalysesWithRunInfoRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningClearanceRulesAnalysesPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllAnalysesWithRunInfo.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllAnalysesWithRunInfo.');
        }

        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
            throw new runtime.RequiredError('entityType','Required parameter requestParameters.entityType was null or undefined when calling findAllAnalysesWithRunInfo.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/analyses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningClearanceRulesAnalysesPageFromJSON(jsonValue));
    }

    /**
     * Fetches all clearance rules analyses
     */
    async findAllAnalysesWithRunInfo(requestParameters: FindAllAnalysesWithRunInfoRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningClearanceRulesAnalysesPage> {
        const response = await this.findAllAnalysesWithRunInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all clearance rules analysis runs
     */
    async findAllRunsRaw(requestParameters: FindAllRunsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScreeningClearanceRulesAnalysisRun>>> {
        if (requestParameters.analysisId === null || requestParameters.analysisId === undefined) {
            throw new runtime.RequiredError('analysisId','Required parameter requestParameters.analysisId was null or undefined when calling findAllRuns.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/analyses/{analysisId}/runs`.replace(`{${"analysisId"}}`, encodeURIComponent(String(requestParameters.analysisId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScreeningClearanceRulesAnalysisRunFromJSON));
    }

    /**
     * Fetches all clearance rules analysis runs
     */
    async findAllRuns(requestParameters: FindAllRunsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScreeningClearanceRulesAnalysisRun>> {
        const response = await this.findAllRunsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get screening clearance rules analysis
     */
    async getAnalysisRaw(requestParameters: GetAnalysisRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningClearanceRulesAnalysis>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getAnalysis.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/analyses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningClearanceRulesAnalysisFromJSON(jsonValue));
    }

    /**
     * Get screening clearance rules analysis
     */
    async getAnalysis(requestParameters: GetAnalysisRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningClearanceRulesAnalysis> {
        const response = await this.getAnalysisRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing screening clearance rules analysis
     */
    async updateAnalysisRaw(requestParameters: UpdateAnalysisRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningClearanceRulesAnalysis>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateAnalysis.');
        }

        if (requestParameters.internalApiScreeningClearanceRulesAnalysis === null || requestParameters.internalApiScreeningClearanceRulesAnalysis === undefined) {
            throw new runtime.RequiredError('internalApiScreeningClearanceRulesAnalysis','Required parameter requestParameters.internalApiScreeningClearanceRulesAnalysis was null or undefined when calling updateAnalysis.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/analyses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScreeningClearanceRulesAnalysisToJSON(requestParameters.internalApiScreeningClearanceRulesAnalysis),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningClearanceRulesAnalysisFromJSON(jsonValue));
    }

    /**
     * Update an existing screening clearance rules analysis
     */
    async updateAnalysis(requestParameters: UpdateAnalysisRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningClearanceRulesAnalysis> {
        const response = await this.updateAnalysisRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
